import React from 'react';
import AppContainer from '../app-container';
import * as participantActions from '../../actions/participant';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import Loading from '../../components/loading';
import ParticipantResultsDisplay from '../../components/participant-results-display';


class ParticipantResultsContainer extends AppContainer {
    componentWillMount() {
        this.props.actions.fetchParticipantResultV2(this.props.params.resultId).then(this.handlePageResult.bind(this));
    }


    render() {
        const {results} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.participantResultsHistory)}>
                <div className="page-section">
                {results.loading || !results.item.participant ? <Loading/> :
                  <div className="container">
                      <h1 className="title">{results.item.participant.first_name} {results.item.participant.last_name}</h1>
                      <ParticipantResultsDisplay items={results.item.results} />
                  </div>}
                </div>

            </DocumentTitle>
        )
    }
}

export default connect(function (state) {
    return {results: state.participant.participantV2};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(ParticipantResultsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/participant-results-v2-page-container.js